<template>
  <div class="ui-accordion">
    <div v-for="(item, index) in items" :key="index" class="ui-accordion__item">
      <Disclosure v-slot="{ open }" :default-open="defaultOpen === index">
        <DisclosureButton class="ui-accordion__button">
          <span class="ui-accordion__title h4">{{ item.title }}</span>

          <UiButtonIconRounded as="span">
            <IconMinus v-if="open" />
            <IconPlus v-else />
          </UiButtonIconRounded>
        </DisclosureButton>

        <UiTransitionExpand>
          <DisclosurePanel>
            <div class="ui-accordion__panel cms-content" v-html="item.content"></div>
          </DisclosurePanel>
        </UiTransitionExpand>
      </Disclosure>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import UiButtonIconRounded from './UiButtonIconRounded.vue'
import UiTransitionExpand from './UiTransitionExpand.vue'
import IconMinus from './icons/IconMinus.vue'
import IconPlus from './icons/IconPlus.vue'

type Item = {
  title: string
  content: string
}

type Props = {
  items: Item[]
  defaultOpen?: number
}

defineProps<Props>()
</script>

<style lang="scss">
@import '../styles/config';

.ui-accordion__item {
  border-bottom: 1px solid $black;

  &:first-child {
    border-top: 1px solid $black;
  }
}

.ui-accordion__button {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 3.25rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: left;
  color: $black;
  @include transition('color');

  .ui-button-icon-rounded {
    margin-left: 1.25rem;
  }

  &:hover {
    text-decoration: none;

    .ui-button-icon-rounded {
      background-color: $black;
      color: $white;
    }
  }

  @include media-breakpoint-up(md) {
    min-height: 5rem;
  }
}

.ui-accordion__title {
  display: block;
  margin-right: auto;
  color: inherit;
}

.ui-accordion__panel {
  padding-top: 0.75rem;
  padding-bottom: 1.5rem;
}
</style>
